<template>
  <div
    class="rounded-borders-lg bdr-a-grey-6 q-pb-lg cursor-pointer"
    @click="$emit('open:lease')"
  >
    <div class="q-pa-lg row items-center bg-primary-pale rounded-borders-lg">
      <QIcon
        name="icon-piggy"
        size="36px"
        class="q-mr-md"
        color="primary"
        v-if="monthSavings !== 0"
      />
      <p v-if="monthSavings !== 0">
        You saved <b>{{ monthSavings | currency }}</b> this month
      </p>
    </div>

    <SummaryExpansionItem>
      <div class="q-pb-md q-pt-lg">
        <span class="text-bold">Your total savings so far</span>
        <div class="row items-center q-mt-sm">
          <h4 class="text-weight-medium col">
            {{ (gstSavingToDate + taxSavingToDate) | currency }}
          </h4>
          <QSeparator vertical color="primary-pale" class="q-mx-md" />
          <div class="col">
            <div class="column q-gutter-y-xs">
              <div class="row items-center">
                <span>{{ gstSavingToDate | currency }}</span>
                <span class="text-tab text-weight-bold q-px-xs">ON GST</span>
                <SAIInformationPopup
                  icon-color="primary-semi-pale"
                  popup-close-color="white"
                >
                  This is an estimate based on vehicle expenses incurred
                </SAIInformationPopup>
              </div>
              <div class="row items-center">
                <span>{{ taxSavingToDate | currency }}</span>
                <span class="text-tab text-weight-bold q-px-xs">ON TAX</span>
                <SAIInformationPopup
                  icon-color="primary-semi-pale"
                  popup-close-color="white"
                >
                  This estimate is based on your salary at the time you applied
                  for your lease. If your salary has changed, your total tax
                  savings may vary from the amount shown.
                </SAIInformationPopup>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SummaryExpansionItem>

    <div class="row justify-center q-mt-lg q-pt-sm">
      <img
        v-if="img"
        :src="img"
        alt="Lease Vehicle"
        class="image-contain"
        :style="{ width: imgWidth }"
      />
    </div>

    <div class="row items-center justify-between q-mt-sm q-px-md">
      <p class="text-weight-bold">{{ rego }}</p>
      <LeaseTermCompletion :current-month="currentMonth" :term="term" />
    </div>

    <div class="q-px-md q-mt-md" @click.stop="$emit('open:budget')">
      <div class="bdr-a-grey-4 rounded-borders-lg q-pa-md">
        <div class="row items-center">
          <QIcon name="icon-money-bag" size="38px" class="q-mr-md" />
          <div class="col column">
            <span class="text-tab text-weight-bold q-pb-xs">
              YOUR CURRENT BALANCE*
            </span>
            <p
              :class="[
                'text-h4',
                {
                  'text-warning': !balanceInSurplus
                }
              ]"
            >
              {{ currentBalance | currency }}
              <QIcon name="eva-alert-triangle" color="orange" size="sm" />
            </p>
            <span class="text-extra-small q-pt-xs text-weight-medium">
              *Does not include finance component
            </span>
          </div>
          <QIcon name="eva-chevron-right-outline" size="md" />
        </div>
        <div
          class="q-mt-sm bg-positive-light q-pa-sm rounded-borders"
          v-if="balanceInSurplus"
        >
          <span class="text-positive">
            Your account is currently in surplus
          </span>
          <SAIInformationPopup popup-close-color="white" icon-color="positive">
            Please note that your account surplus does not forecast future
            expenses e.g. insurance premiums paid annually which are yet to be
            paid.
          </SAIInformationPopup>
        </div>
        <div class="q-mt-sm bg-warning-light q-pa-sm rounded-borders" v-else>
          <span class="text-warning">
            Your account is currently in arrears
          </span>
          <SAIInformationPopup popup-close-color="white" icon-color="warning">
            <p class="text-body q-mb-sm">
              Your budget arrears may be due to a recent payment of a large
              annual expense, in which case, no action is required.
            </p>
            <p class="text-body">
              Or, your driving patterns do not match your budget, in which case,
              we can help you to adjust your budget. Adjusting your budget
              gradually, means you won't have a large out of pocket expense at
              the end of your lease. Please book a time for a call back to
              discuss your options.
            </p>
          </SAIInformationPopup>
        </div>
      </div>
    </div>

    <div class="column q-px-md">
      <SAIBtn
        no-caps
        class="q-mt-md"
        label="View my lease details"
        padding="8px lg"
        @click="$emit('open:lease')"
      />
    </div>
  </div>
</template>

<script>
import { QIcon, QSeparator } from 'quasar';
import { SAIBtn, SAIInformationPopup } from 'ecx.saigon.ui.common';

export default {
  name: 'LeaseCard',
  props: {
    monthSavings: Number,
    gstSavingToDate: Number,
    taxSavingToDate: Number,
    img: String,
    rego: String,
    term: Number,
    currentMonth: Number,
    currentBalance: Number,
    imgWidth: {
      type: String,
      default: '180px'
    }
  },
  computed: {
    balanceInSurplus() {
      return this.currentBalance > 0;
    }
  },
  components: {
    QIcon,
    SAIBtn,
    QSeparator,
    SAIInformationPopup,
    LeaseTermCompletion: () => import('../../molecule/lease-term-completion'),
    SummaryExpansionItem: () => import('../../molecule/summary-expansion-item')
  }
};
</script>
